export default __webpack_public_path__ + "static/media/2.27bfd856.mp4";